import { Component, OnInit, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CasesService } from 'src/app/services/cases/cases.service';
import { ErrorSnackbarComponent } from 'src/app/snackbars/error-snackbar/error-snackbar.component';
import { LoadingScreenComponent } from '../../shared/loading-screen/loading-screen.component';

@Component({
  selector: 'app-claims-rerouter',
  templateUrl: './claims-rerouter.component.html',
  styleUrls: ['./claims-rerouter.component.scss'],
  imports: [LoadingScreenComponent],
})
export class ClaimsRerouterComponent implements OnInit {
  private casesService = inject(CasesService);
  private route = inject(ActivatedRoute);
  private translate = inject(TranslateService);
  private router = inject(Router);
  private snackBar = inject(MatSnackBar);

  async ngOnInit() {
    const claimToken = this.route.snapshot.params.claimToken;
    try {
      const { payee_case_id } =
        await this.casesService.getCaseByClaimToken(claimToken);
      return this.router.navigateByUrl(`case/${payee_case_id}`);
    } catch (error) {
      console.error(error);

      this.snackBar.openFromComponent(ErrorSnackbarComponent, {
        data: {
          message: this.translate.instant(
            'ERROR_MESSAGES.ERROR_WHILE_LOADING_CASE',
          ),
          action: this.translate.instant('OK'),
        },
        duration: 10000,
      });
      return this.router.navigateByUrl('/login');
    }
  }
}
